/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import { Box } from '@mui/material';
import BaseShimmer from './BaseShimmer';
import './shimmer.scss';

function FooterShimmer({ className = '', style = {} }) {
  return (
    <Box className={`shimmer-footer ${className}`} sx={style}>
      <Box className="shimmer-footer-content">
        {Array.from({ length: 4 }).map((_, columnIndex) => (
          <Box key={columnIndex} className="shimmer-footer-column">
            <BaseShimmer
              className="shimmer-footer-title"
              height="24px"
              width="80%"
              borderRadius="4px"
            />
            {Array.from({ length: 4 }).map((_, itemIndex) => (
              <BaseShimmer
                key={itemIndex}
                className="shimmer-footer-item"
                height="16px"
                width={itemIndex === 0 ? '70%' : itemIndex === 1 ? '50%' : itemIndex === 2 ? '65%' : '60%'}
                borderRadius="4px"
              />
            ))}
          </Box>
        ))}
      </Box>

      <Box className="shimmer-footer-bottom">
        <BaseShimmer
          className="shimmer-footer-copyright"
          height="16px"
          width="200px"
          borderRadius="4px"
        />

        <Box className="shimmer-footer-links">
          <BaseShimmer
            className="shimmer-footer-link"
            height="16px"
            width="80px"
            borderRadius="4px"
          />
          <BaseShimmer
            className="shimmer-footer-link"
            height="16px"
            width="80px"
            borderRadius="4px"
          />
        </Box>
      </Box>
    </Box>
  );
}

export default FooterShimmer;
